import React from "react";
import "./Services.css";
import Card from "./Card";
function Services() {
  return (
    <div className="services">
      <div className="services__brand"></div>
      <h2 className="services__brandName">
        <span>Worth Emphasizing...</span>
      </h2>
      <h3 className="services__tagline">
        Providing the best solution to match your expected standards, Quality
        service
      </h3>
      <div className="services__cards">
        <Card
          imageSrc={"./diamond.png"}
          title={"Web Solution"}
          body="Shaping online offices, Startups ,Local Shops, Markets, E-commerce via filtering best and right solutions .precision in delivery"
        />
        <Card
          imageSrc={"./bulb.png"}
          title={"Strategy & Research"}
          body="My process includes a deep research on strategy , I have a lot of plannings going around to ensure the delivery of quality product "
        />
        <Card
          imageSrc={"./webDev.png"}
          title={"Web Development"}
          body="Make your website standout among the billion other ,I have a synthetical and Creative driven approach towards every problem "
        />
      </div>
    </div>
  );
}

export default Services;
